import React, { useLayoutEffect, useRef, useState } from 'react';
import IconFont from '$/components/IconFont';
import classNames from 'classnames';
import VipBadge from '@/components/AITools/VipBadge';
import style from './index.module.scss';

const LABEL_DEFAULT_FONT_SIZE = 14;
const LABEL_MIN_FONT_SIZE = 12;

/**
 * 标签文案自适应字号：最多展示 2 行，超出时按 1px 逐级缩小，最小 12px。
 */
function useAdaptiveTwoLineLabelFontSize(text: string) {
  const labelRef = useRef<HTMLSpanElement>(null);
  const [fontSize, setFontSize] = useState(LABEL_DEFAULT_FONT_SIZE);

  useLayoutEffect(() => {
    const labelEl = labelRef.current;
    if (!labelEl) return;

    let nextFontSize = LABEL_DEFAULT_FONT_SIZE;
    for (; nextFontSize >= LABEL_MIN_FONT_SIZE; nextFontSize -= 1) {
      labelEl.style.fontSize = `${nextFontSize}px`;
      const { scrollHeight, clientHeight } = labelEl;
      if (scrollHeight <= clientHeight + 1) {
        break;
      }
    }

    setFontSize(nextFontSize);
  }, [text]);

  return { labelRef, fontSize };
}

interface SelectionBoxProps {
  icon: string ;
  value: string | number;
  label: string;
  active: boolean;
  onClick?: (value: string | number) => void;
  /** 为 true 时不可点击 */
  disabled?: boolean;
  vipBadge?: boolean;
}
export default function SelectionBox({
  icon,
  value,
  label,
  active,
  onClick,
  disabled = false,
  vipBadge = false,
}: SelectionBoxProps) {
  const { labelRef, fontSize } = useAdaptiveTwoLineLabelFontSize(label);

  return (
    <div
      className={classNames(style.selection_box, {
        [style.active]: active,
        [style.disabled]: disabled,
      })}
      onClick={() => {
        if (disabled) return;
        onClick?.(value);
      }}
    >
      {vipBadge && <VipBadge variant="black" className={style.vip_badge} />}
      <IconFont name={icon} fontSize={22} color="var(--content-primary)" className={style.selection_box_icon} />
      <span
        ref={labelRef}
        className={style.selection_box_label}
        style={{ fontSize }}
      >
        {label}
      </span>
    </div>
  );
}
